import React from "react";
import PropTypes from "prop-types";

import Button from "core/Button";
import BodyText from "core/BodyText";

import DroppedFileErrors from "./DroppedFileErrors";

import {
    FooterSectionContainer,
    FooterFlexbox,
    ErrorContainer,
    SmallBlueTextLink,
    UploadMoreButton
} from "./styles";

const Footer = ({
    hasAcceptedFiles,
    handleOpenFilePicker,
    hasHeaderHeight,
    minFileSizeBytes,
    maxFileSizeBytes,
    hasRejectedFileErrors,
    handleClearErrors,
    rejectedFilesCount
}) => {
    const isDisabled =
        (hasAcceptedFiles && hasAcceptedFiles.length === 0) ||
        !hasAcceptedFiles ||
        !!rejectedFilesCount; // TODO in future PR: add check to make sure user has not hit their limit

    return (
        <FooterSectionContainer
            topSpacing="2xl"
            bottomSpacing="2xl"
            hasHeaderHeight={hasHeaderHeight}
        >
            {!!rejectedFilesCount && (
                <ErrorContainer>
                    <DroppedFileErrors
                        minFileSizeBytes={minFileSizeBytes}
                        maxFileSizeBytes={maxFileSizeBytes}
                        hasRejectedFileErrors={hasRejectedFileErrors}
                        handleClearErrors={handleClearErrors}
                        rejectedFilesCount={rejectedFilesCount}
                    />
                </ErrorContainer>
            )}

            <FooterFlexbox justifyContent="space-between" alignItems="center">
                <BodyText size="sm" type="div">
                    <SmallBlueTextLink href="#">
                        Read our guidelines
                    </SmallBlueTextLink>

                    {!isDisabled && (
                        <UploadMoreButton
                            onClick={e => handleOpenFilePicker(e)}
                        >
                            Upload more photos
                        </UploadMoreButton>
                    )}
                </BodyText>

                <Button isDisabled={isDisabled}>Submit</Button>
            </FooterFlexbox>
        </FooterSectionContainer>
    );
};

Footer.propTypes = {
    hasAcceptedFiles: PropTypes.array,
    handleOpenFilePicker: PropTypes.func,
    hasHeaderHeight: PropTypes.number,
    minFileSizeBytes: PropTypes.number.isRequired,
    maxFileSizeBytes: PropTypes.number.isRequired,
    hasRejectedFileErrors: PropTypes.array.isRequired,
    handleClearErrors: PropTypes.func.isRequired,
    rejectedFilesCount: PropTypes.number.isRequired
};

export default Footer;
